let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("aCDMn")]).then(() => parcelRequire('bSCN7'));